import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

const DEEP_LINK_HOSTS = ['moneyewallet.me', 'smartpay-flexi-wallet.lovable.app'];

export function useDeepLink() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const handleAppUrlOpen = (event: { url: string }) => {
      console.log('🔗 Deep link received:', event.url);

      try {
        const url = new URL(event.url);

        // Only handle our known hosts
        if (!DEEP_LINK_HOSTS.includes(url.hostname)) return;

        const path = url.pathname + url.search;
        if (path && path !== '/') {
          console.log('🔗 Navigating to:', path);
          navigate(path);
        }
      } catch (error) {
        console.error('🔗 Failed to parse deep link URL:', error);
      }
    };

    App.addListener('appUrlOpen', handleAppUrlOpen);

    return () => {
      App.removeAllListeners();
    };
  }, [navigate]);
}
